export const getInvoices = (state) => state.invoices

